import { ComponentInternalInstance, computed, getCurrentInstance, onUnmounted, Ref } from '@vue/composition-api';

import i18n, { i18n_t } from '@/locales/i18n';
import { drawerHandler } from '@/renderer/scripts/composition/drawerHandler';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import { SMH } from '@/renderer/scripts/libs/smh-sdk-class';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import ipc from '@/renderer/scripts/utils/ipc';
import store from '@/renderer/store';
import storage from '@/renderer/scripts/utils/storage';

/**
 *
 * @param spaceId
 * @param isShowMemberManage
 */
export const useDrawer = (spaceId: string, isShowMemberManage: Ref<boolean>) => {
  const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const groupSelected = computed(() => vm.$store.getters.drawerSelected?.[0]);
  const { $router } = vm;
  // 抽屉相关的代码块
  const { drawerHandlerMethods } = drawerHandler();
  // 初始化的时候，立刻初始化详情组件
  const emptyScope: Drawer.EmptyScope = {
    title: '',
    componentName: 'EmptyDetail',
    params: {
      totalMsg: i18n_t('共有0个文件'),
      title: i18n_t('查看详情信息'),
      desc: i18n_t('选中文件/文件夹查看更详细信息'),
      imgClass: '',
    },
  };
  const dynamicScope: Drawer.CollaborationDynamicScope<SMH.SpaceFileItemData> = {
    title: i18n_t('动态'),
    componentName: 'Dynamic',
    params: {
      selectedItem: groupSelected.value,
      spaceId: groupSelected.value?.spaceId,
      spaceOrgId: groupSelected.value?.orgId,
      buttonTitle:
        groupSelected.value?.ownerId === vm.$store.getters.userId &&
        groupSelected.value?.orgId === vm.$store.getters.orgId
          ? i18n_t('外链管理')
          : undefined,
      buttonEvent: () => {
        dispatchRouter({ name: 'collaborationShareList' });
      },
    },
  };
  const authScope: Drawer.CollaborationAuthScope<SMH.SpaceFileItemData> = {
    title: i18n_t('成员管理'),
    componentName: 'CollaborationMemberManage',
    params: {
      selectedItem: groupSelected.value,
      spaceId: groupSelected.value?.spaceId,
      groupId: groupSelected.value?.id,
    },
  };
  const methods = {
    setDrawers() {
      if (isShowMemberManage.value) {
        drawerHandlerMethods.setDrawers([dynamicScope, authScope]);
      } else {
        drawerHandlerMethods.setDrawers([dynamicScope]);
      }
    },
    setTotal: (total: number) => {
      store.commit(DrawerEvents.SET_TOTAL, total);
    },
    selectedChange: (selectedList: SMH.SpaceFileItemData[]) => {
      if (selectedList.length === 0) {
        methods.setDrawers();
      }
      if (selectedList.length === 1) {
        // 初始化的时候，立刻初始化详情组件
        const detailScope: Drawer.DetailScope<SMH.SpaceFileItemData> = {
          title: i18n_t('详细信息'),
          componentName: 'Detail',
          // 个人版本的spaceId会自动传递
          params: { selectedItem: selectedList[0], spaceId },
        };
        const dynamicScope: Drawer.DynamicScope<SMH.SpaceFileItemData> = {
          title: i18n_t('动态'),
          componentName: 'Dynamic',
          // 个人版本的spaceId 传递为空字符
          params: { selectedItem: selectedList[0], spaceId },
        };
        const historyScope: Drawer.HistoryScope<SMH.SpaceFileItemData> = {
          title: i18n_t('历史版本'),
          componentName: 'History',
          // 个人版本的spaceId 传递为空字符
          params: { selectedItem: selectedList[0], spaceId },
        };
        // 个人空间
        if (selectedList[0].type === 'dir') {
          drawerHandlerMethods.setDrawers([detailScope, dynamicScope]);
        } else {
          drawerHandlerMethods.setDrawers([detailScope, historyScope]);
        }
      }
      if (selectedList.length > 1) {
        drawerHandlerMethods.setDrawers([emptyScope]);
      }
    },
  };
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, methods.setTotal);
  ipc.on(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, methods.selectedChange);
  onUnmounted(() => {
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_SELECTED_CHANGE, methods.selectedChange);
    ipc.off(ipc.RENDERER_EVENTS_MAP.ON_DATA_LOADED, methods.setTotal);
  });
  return {
    groupSelected,
    methods,
  };
};
